var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"sp-pagenation",attrs:{"current-page":_vm.current,"page-size":_vm.pageSize,"prev-text":"上一页","next-text":"下一页","layout":"prev, pager, next, total, jumper","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }